import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  profilType : string ;
  constructor(
    private router : Router,
    private authService : AuthenticationService
  ) { }

  ngOnInit(): void {
    this.profilType = localStorage.getItem('profil');
  }

  logOut(){
    this.authService.logOut();
    this.router.navigate(['accueil']);
  }

}
